import module from 'nominas/nomina/module.js'

export class NominasNominaExportarServicios {
  constructor ($q, NominasNomina, NominasNominaSuministro, NominasNominaConceptos, NominasNominaEmpleados) {
    this.$q = $q
    this.NominasNomina = NominasNomina
    this.NominasNominaSuministro = NominasNominaSuministro
    this.NominasNominaConceptos = NominasNominaConceptos
    this.NominasNominaEmpleados = NominasNominaEmpleados
  }

  get (idEmpresa, idNomina, logotipo, separarSalas, omitir_conceptos, departamentos) {
    return this.$q.all({
      nomina: this.NominasNomina.get(idEmpresa, idNomina),
      suministro: this.NominasNominaSuministro.get(idEmpresa, idNomina),
      colaboradores: this.NominasNominaEmpleados.get(idEmpresa, idNomina),
      conceptos: this.NominasNominaConceptos.get(idEmpresa, idNomina),
    })
      .then((response) => {
        let nomina = response.nomina
        let nominaConceptos = response.conceptos.map(item => ({
          Concepto: item.Concepto,
          ID_Concepto: item.ID_Concepto,
          total: 0,
        }))
        
        let nominaColaboradores = response.colaboradores
        let nominaSuministro = response.suministro
        let pages = []
        let pages_indexed = {}

        // Detallado
        nominaSuministro.forEach((suministro, index) => {
          let empleado = nominaColaboradores[index]

          if (!empleado) {
            throw 'No se encontró al empleado ' + index
          }

          let elemento = {
            empresa_id: empleado.ID_Empresa,
            empleado_id: empleado.ID_Empleado,
            empleado: empleado.Empleado || '',
            departamento: empleado.Departamento,
            subtotal: suministro.Subtotal,
            comision_porcentaje: suministro.Comision_Porcentaje,
            Comision_Importe: suministro.Comision_Importe,
            total: suministro.Total,
            saldo: suministro.Saldo,
          }

          let total_deducciones = 0
          let total_pagar = suministro.Total

          nominaConceptos.forEach((concepto) => {
            let deduccion = suministro.Deducciones[concepto.ID_Concepto]
            let importe = Number.isFinite(deduccion.editado) ? deduccion.editado : deduccion.calculado

            total_deducciones += importe
            total_pagar -= importe
            concepto.total += importe
            let atributo = `j_${concepto.ID_Concepto}`
            elemento[atributo] = importe
          })

          elemento.total_deducciones = total_deducciones
          elemento.total_pagar = total_pagar

          if (!pages_indexed['Todos']) {
            pages_indexed['Todos'] = new PageDetallado('Nómina ' + nomina['ID_Nomina'])
            pages.push(pages_indexed['Todos'])
          }

          pages_indexed['Todos'].data.push(Object.values(elemento))

          if (separarSalas) {
            if (!pages_indexed[empleado.Departamento]) {
              pages_indexed[empleado.Departamento] = new PageDetallado('Sala ' + empleado.Departamento)
              pages.push(pages_indexed[empleado.Departamento])
            }
            pages_indexed[empleado.Departamento].data.push(Object.values(elemento))
          }
        })

        pages.forEach(page => {
          page.columns = [
            {label: 'Empr.', format: {align: 'center', width: 4}},
            {label: 'ID', format: {align: 'center', width: 7}},
            {label: 'Nombre', format: {width: 30}},
            {label: 'Dpto.', format: {width: 10}},
            {label: 'Subtotal', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
            {label: '%', format: {type: 'percent', align: 'center', width: 5}},
            {label: 'Comision', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
            {label: 'Total', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
            {label: 'Saldo', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
          ]
          if (!departamentos) {
            page.columns.splice(3, 1)
            page.data.forEach(item => {
              item.splice(3, 1)
            })
          }
          page.columns = [...page.columns]
            .concat(nominaConceptos
              .filter((concepto) => {
                if (!concepto.total && omitir_conceptos) {
                  page.data.forEach(item => {
                    let atributo = `j_${concepto.ID_Concepto}`
                    delete item[atributo]
                  })
                }
                return concepto.total || !omitir_conceptos
              })
              .map((item) => {
                return {
                  label: item.Concepto, format: {type: 'currency', align: 'right', width: 10}, totalize: true,
                }
              }))
            .concat([
              {label: 'Total deducciones', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
              {label: 'Total a pagar', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
            ])
        })

        return pages

        function PageDetallado (Departamento) {
          return {
            name: Departamento,
            details: [
              {label: 'Empresa: ' + nomina.Empresa, cell: 'D1'},
              {label: 'Nómina: ' + nomina.ID_Nomina, cell: 'D2'},
              {label: 'Moneda: ' + nomina.Moneda, cell: 'D3'},
              {label: 'Departamento: ' + Departamento, cell: 'D4'},
              {label: 'Fecha: ' + nomina.Fecha.toYMD(), cell: 'I1'},
              {label: 'Fecha de pago: ' + nomina.Fecha_Pago.toYMD(), cell: 'I2'},
            ],
            columns: [],
            options: {
              logo: {
                filename: logotipo,
                title: 'FAN Consultores',
                cell: 'A1',
              },
              show_grid: false,
              fixed_column: 'A8',
            },
            data: [],
          }
        }
      })
  }

}

module.service('NominasNominaExportarServicios', NominasNominaExportarServicios)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar/Servicios.js